/* eslint-disable no-case-declarations */
import PATHS from 'lib/navigation/paths';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import React, { useMemo } from 'react';
import { DealCardV2 } from 'views/rebranded-module/common/components';
import { REF, DEAL_TYPES } from 'views/rebranded-module/common/utils/constants';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

const DealCardWrapper = (props) => {
  const { dealItem, content } = props;
  const dealValue = useMemo(() => {
    const valueWCMoneyObj = moneyFormat(
      Dinero({
        amount: dealItem.value_wc.amount,
        currency: dealItem.value_wc.currency_code,
        precision: dealItem.value_wc.precision,
      }),
    );

    switch (dealItem.deal_type_sym_id) {
      case DEAL_TYPES.PACKAGE_PRICE:
        return {
          oldValue: valueWCMoneyObj,
          dealValue: moneyFormat(
            Dinero({
              amount: dealItem.discounted_price.amount,
              currency: dealItem.discounted_price.currency_code,
              precision: dealItem.discounted_price.precision,
            }),
          ),
        };

      case DEAL_TYPES.TOUR:
      case DEAL_TYPES.TOUR_WITH_OPERATIONAL_DAYS:
      case DEAL_TYPES.DISCOUNT_PERCENT:
        return {
          dealValue: interpolateString(content.off, {
            value: +dealItem.discounted_price,
          }),
        };

      case DEAL_TYPES.DISCOUNT_AMOUNT:
        return {
          dealValue: interpolateString(content.offAmount, {
            value: moneyFormat(
              Dinero({
                amount: dealItem.discounted_price.amount,
                currency: dealItem.discounted_price.currency_code,
                precision: dealItem.discounted_price.precision,
              }),
            ),
          }),
        };

      case DEAL_TYPES.DAILY_RATE: {
        const discountedValue = moneyFormat(
          Dinero({
            amount: dealItem.discounted_price.amount,
            currency: dealItem.discounted_price.currency_code,
            precision: dealItem.discounted_price.precision,
          }),
        );
        return {
          oldValue: interpolateString(content.day, {
            value: valueWCMoneyObj,
          }),
          dealValue: interpolateString(content.day, {
            value: discountedValue,
          }),
        };
      }
      case DEAL_TYPES.ONE_WAY_SPECIAL:
        return {
          dealValue: content.oneWaySpecial,
        };

      case DEAL_TYPES.BUY_ONE_DAY_GET_ONE:
        return {
          dealValue: content.bego,
        };

      case DEAL_TYPES.BUY_X_DAYS_GET_Y_DAYS:
        return {
          dealValue: interpolateString(content.buyXDaysGetYDaysFreeLabel, {
            paid_days: dealItem.paid_days,
            paid_day_label:
              dealItem.paid_days > 1
                ? content.dealDayPlural
                : content.dealDaySingular,
            free_days: dealItem.free_days,
            free_day_label:
              dealItem.free_days > 1
                ? content.dealDayPlural
                : content.dealDaySingular,
          }),
        };

      default:
        return {};
    }
  }, [dealItem]);

  return (
    <DealCardV2
      title={dealItem.title}
      image={{
        src: dealItem.img_url,
        alt: dealItem.title,
      }}
      link={PATHS.motorcycleDeals.slug(dealItem.identifier, {
        ref: REF.DEALS_LOCATION_REF,
      })}
      tagline={dealItem.tagline}
      {...dealValue}
    />
  );
};

export { DealCardWrapper };
